import { HumanizedDateCell, Link } from '@/components/ui'
import type { ColumnDef } from '@/components/ui/table/types'
import { getProjectPath, numberToCurrency } from '@/utils'
import { billableAmount, billableHours } from '../../billing'
import type { Project } from './types'

const formatHours = (hours: number): string =>
  hours < 1 ? `${Math.round(hours * 60)} min` : `${hours.toFixed(1)} hrs`

// The per-case billing lines: the same rows a partner would drop into an invoice.
export const billingColumns: ColumnDef<Project, any>[] = [
  {
    accessorKey: 'name',
    header: 'Case',
    meta: { isFluid: true },
    size: 280,
    cell: ({ row }) => (
      <Link
        to={getProjectPath(row.original)}
        className="font-medium text-blue-7 hover:underline"
      >
        {row.original.name}
      </Link>
    ),
  },
  {
    accessorKey: 'numberOfPages',
    header: 'Pages',
    size: 100,
  },
  {
    id: 'billableHours',
    header: 'Billable hours',
    size: 130,
    accessorFn: (row) => billableHours(row.numberOfPages),
    cell: ({ getValue }) => formatHours(getValue<number>()),
  },
  {
    id: 'amount',
    header: 'Amount',
    size: 130,
    accessorFn: (row) => billableAmount(row.numberOfPages),
    cell: ({ getValue }) => (
      <span className="font-medium tabular-nums text-blue-7">
        {numberToCurrency(getValue<number>(), { maximumFractionDigits: 0 })}
      </span>
    ),
  },
  {
    accessorKey: 'firstProcessedAt',
    header: 'Processed',
    size: 130,
    cell: HumanizedDateCell,
  },
  {
    accessorKey: 'createdAt',
    header: 'Created',
    size: 130,
    cell: HumanizedDateCell,
  },
]
